import r from "../../../node_modules/validator/index.js";
import { t } from "../../i18/index.js";
import { paramCase as n } from "../../../node_modules/param-case/dist.es2015/index.js";
function i(r, t) {
  (null == t || t > r.length) && (t = r.length);
  for (var n = 0, i = Array(t); n < t; n++) i[n] = r[n];
  return i;
}
var e = function e(t) {
    return !t || r.isNumeric(t);
  },
  o = function o(t) {
    return !t || r.isEmail(t);
  },
  u = function u(t) {
    return !t || r.isFQDN(t);
  },
  s = function s(t) {
    return !t || r.isFQDN(t) || r.isIP(t);
  },
  l = function l(t) {
    return !t || r.isURL(t, {
      require_protocol: !0,
      protocols: ["http", "https"]
    });
  },
  a = function a(t) {
    return !t || r.isURL(t, {
      require_protocol: !0,
      protocols: ["https"]
    });
  },
  f = function f(t) {
    return !t || r.isURL(t, {
      require_protocol: !0
    });
  },
  c = function c(t) {
    return !t || r.isURL(t, {
      require_tld: !1,
      require_valid_protocol: !1
    });
  },
  p = function p(r) {
    var t = (r || "").split(".");
    return 4 !== t.length ? 0 : t.reduce(function (r, t) {
      return (r << 8) + parseInt(t, 10);
    }, 0) >>> 0;
  },
  m = function m(t) {
    if (!t) return !0;
    var n = t.split(["-"]);
    if (1 === n.length) return r.isIP(n[0].trim());
    if (2 === n.length) {
      var i = n[0].trim(),
        e = n[1].trim();
      if (!e || !r.isIP(i) || !r.isIP(e)) return !1;
      if (i === e || p(e) > p(i)) return !0;
    }
    return !1;
  },
  d = function d(r) {
    if (r.includes("/")) {
      var t,
        n,
        i,
        e = r.split("/");
      if (2 !== e.length) return !1;
      n = e[0], i = e[1];
    } else n = r;
    var o = n.split(".");
    return !(4 !== o.length || o.some(function (r) {
      return !(!isNaN(+r) && r.length > 0 && r.length <= 3 && 256 > +r && +r >= 0);
    })) && (!i || !isNaN(+(t = i)) && t.length <= 2 && 32 >= +t && +t >= 0);
  },
  h = function h(t) {
    return "" !== r.trim(t.toString());
  },
  g = function g(r, t) {
    return parseInt(r) <= parseInt(t);
  },
  v = function v(r, t) {
    return parseInt(r) >= parseInt(t);
  },
  y = function y(t, n) {
    return !t || r.trim(t).length >= n;
  },
  I = function I(t, n) {
    return r.trim(String(t)).length <= n;
  },
  b = /^[A-Z2-7]+=*$/,
  U = function U(r) {
    return !r || b.test(r);
  },
  q = {
    isBase32: U,
    isEmail: o,
    isFqdn: u,
    isFqdnOrIp: s,
    isHttpUrl: l,
    isHttpsUrl: a,
    isIpRange: m,
    isNumeric: e,
    isRequired: h,
    isUrl: c,
    isUrlWithProtocol: f,
    max: g,
    maxLength: I,
    min: v,
    minLength: y
  },
  x = Object.keys(q);
function N(r) {
  for (var e = arguments.length, o = Array(e > 1 ? e - 1 : 0), u = 1; u < e; u++) o[u - 1] = arguments[u];
  var s = o[0],
    l = o[1];
  return 2 == arguments.length && (s = "field", l = o[0]), x.filter(function (r) {
    return r in l && !1 !== l[r] && void 0 !== l[r];
  }).map(function (t) {
    var n = q[t],
      i = 1 === n.length ? n(r) : n(r, l[t]);
    return [t, i];
  }).map(function (e) {
    var o = function (r) {
        if (Array.isArray(r)) return r;
      }(e) || function (r, t) {
        var n,
          i,
          e = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != e) {
          var o = [],
            u = !0,
            s = !1;
          try {
            for (e = e.call(r); !(u = (n = e.next()).done) && (o.push(n.value), !t || o.length !== t); u = !0);
          } catch (r) {
            s = !0, i = r;
          } finally {
            try {
              u || null == e.return || e.return();
            } finally {
              if (s) throw i;
            }
          }
          return o;
        }
      }(e, 2) || function (r, t) {
        if (r) {
          if ("string" == typeof r) return i(r, t);
          var n = Object.prototype.toString.call(r).slice(8, -1);
          if ("Object" === n && r.constructor && (n = r.constructor.name), "Map" === n || "Set" === n) return Array.from(n);
          if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(r, t);
        }
      }(e, 2) || function () {
        throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }(),
      u = o[0];
    if (!o[1]) {
      var a = r.length > 32 ? r.substring(0, 32) + "..." : r;
      return t("validation-errors." + n(u), {
        name: s,
        key: u,
        value: r,
        shortValue: a,
        0: l[u]
      });
    }
  }).filter(function (r) {
    return r;
  });
}
export { x as ValidatorKeys, q as Validators, v as aboveMin, N as applyValidationsToProps, g as belowMax, I as belowMaxLength, y as hasMinLength, p as ipToInt, U as isBase32, o as isEmail, u as isFqdn, s as isFqdnOrIp, l as isHttpUrl, a as isHttpsUrl, m as isIpRange, d as isIpv4Cidr, e as isNumeric, h as isRequired, c as isUrl, f as isUrlWithProtocol };